import {useGoogleClassroomConnectionQuery} from './GoogleClassroomConnection.queries.generated';

export interface GoogleClassroomConnection {
  /** `undefined` while the answer is unknown: still loading, skipped, or the query failed. */
  isConnected: boolean | undefined;
  isLoading: boolean;
}

/**
 * Whether the signed-in teacher holds a working Google Classroom connection, as the backend
 * reports it from the stored credentials. This is the truth the importer button and the
 * grade-sync cells key off; it is false again once a connect is cancelled or access is revoked.
 */
export function useGoogleClassroomConnection({skip = false} = {}): GoogleClassroomConnection {
  const {data, loading} = useGoogleClassroomConnectionQuery({skip});

  return {
    isConnected: data ? !!data.currentUser?.googleClassroomConnected : undefined,
    isLoading: loading
  };
}
